import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap/js/dist/base-component'
import 'bootstrap/js/dist/button'
import 'bootstrap/js/dist/dropdown'
// import './bootstrap.sass'
import 'bootstrap/dist/css/bootstrap.css'
import { setBackend, ready, getBackend } from '@tensorflow/tfjs'
import '@tensorflow/tfjs-backend-webgpu'

setBackend('webgpu').catch(() => setBackend('webgl')).then(() => ready()).then(() => {
  console.log(`[tfjs] backend in use: ${getBackend()}`)
  createApp(App).mount('#app')
})
